let MAP_API = 'AIzaSyBib6CAqY9NS0sTy3BuaaXkZYuJtdH08bQ'; 
export default MAP_API;

